<template>
  <f7-page
    name="compromiso"
    :infinite-distance="50"
    :infinite-preloader="false"
    infinite
    @page:beforeout="onPageClose"
    :hide-bars-on-scroll="false"
  >
    <f7-navbar
      :sliding="false"
      innerClass="navbar-separator"
    >
      <!-- <f7-link class="text-white" icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link> -->
      <f7-nav-title class="text-madai">Compromiso</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-md="material:search" href="/buscar/" @click="activarBusqueda = false"></f7-link>
      </f7-nav-right>

      <busqueda
        :activarBusqueda="activarBusqueda"
        :id="'busqueda'"
        :catalogo="catalogo"
        :filtros="filtros"
        @searchbar:disable="activarBusqueda = false"
        @search:load-complete="resp => catalogoPaginador = resp"
        @search:data="resp => catalogoFiltrado = resp"
      ></busqueda>
    </f7-navbar>

    <f7-toolbar tabbar scrollable position="top" class="h-60">
      <f7-link class="text-filter-blue bold">
        Filtros
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'corte' }"
        @click="filtro = 'corte'"
        :tab-link-active="filtro === 'corte'"
        v-if="!diamante.Carat"
      >
        <img src="assets/img/filtros/corte-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[1].value === '*' ? 'Corte' : obtenerEstiloCorregido(filtros[1].value) }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'precio' }"
        @click="filtro = 'precio'"
        :tab-link-active="filtro === 'precio'"
      >
        <img src="assets/img/filtros/precio-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[0].minValue === Math.trunc(priceMin) && filtros[0].maxValue === Math.trunc(priceMax) ? 'precio' : 'filtrado' }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'decorativa' }"
        @click="filtro = 'decorativa'"
        :tab-link-active="filtro === 'decorativa'"
      >
        <img src="assets/img/filtros/decorativa-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[2].value === '*' ? 'Decorativa' : filtros[2].value }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'material' }"
        @click="filtro = 'material'"
        :tab-link-active="filtro === 'material'"
      >
        <img src="assets/img/filtros/material-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[3].value === '*' ? 'Material' : filtros[3].value }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'color' }"
        @click="filtro = 'color'"
        :tab-link-active="filtro === 'color'">
        <img src="assets/img/filtros/color-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[4].value === '*' ? 'Color' : filtros[4].value }}
        </div>
      </f7-link>
      <f7-link
        class="text-filter-blue bold"
        @click="limpiarFiltros()"
      >
        Reiniciar
      </f7-link>
    </f7-toolbar>

    <pasos></pasos>

    <f7-list v-if="catalogoPaginador.length === 0">
      <f7-list-item>No se encontraron resultados</f7-list-item>
    </f7-list>

    <template v-else>
      <f7-block class="m-t-15 m-b-5">
        <div class="text-center fs-16 alert alert-danger-2 alert-shadow">Precio no incluye valor del Diamante.</div>
      </f7-block>

      <f7-list class="f7-list-item-no-border m-t-10 m-b-0">
        <f7-list-item
          v-for="(itm, idx) in catalogoPaginador"
          :key="idx"
          :link="`/compromiso/${itm.idac_articles}/`"
        >
          <list-compromiso :itm="itm" />
        </f7-list-item>
      </f7-list>

      <template v-if="catalogo.length > catalogoPaginador.length && catalogoPaginador.length < catalogoFiltrado.length">
        <div class="text-center m-t-20 p-l-15 p-r-15">
          <f7-button @click="$evento.emit('search:load')" large raised fill>Cargar más</f7-button>
        </div>
      </template>

      <!-- Banner envío -->
      <f7-block class="text-center">
        <img class="wd-100" src="assets/img/banners/msi.jpg" alt="">
        <img class="wd-100" src="assets/img/banners/envio_asegurado.jpg" alt="">
        <img class="m-t-40 m-b-20" src="assets/img/otros/ssl-secure.jpg" alt="" style="border-radius: 10px;" height="50">
      </f7-block>
    </template>

    <f7-sheet class="h-370 sheet-border-radius-15" :opened="filtro === 'corte'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Corte</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="m-t-15 p-5 p-l-15 p-r-15">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'redondo' }"
            @click="filtros[1].value === 'redondo' ? filtros[1].value = '*' : filtros[1].value = 'redondo'"
          >
            <img src="assets/img/corte/redondo.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Redondo</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'princess' }"
            @click="filtros[1].value === 'princess' ? filtros[1].value = '*' : filtros[1].value = 'princess'"
          >
            <img src="assets/img/corte/princess.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Princesa</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'asscher' }"
            @click="filtros[1].value === 'asscher' ? filtros[1].value = '*' : filtros[1].value = 'asscher'"
          >
            <img src="assets/img/corte/asscher.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Asscher</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'corazon' }"
            @click="filtros[1].value === 'corazon' ? filtros[1].value = '*' : filtros[1].value = 'corazon'"
          >
            <img src="assets/img/corte/corazon.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Corazón</span>
          </f7-col>
        </f7-row>
        <f7-row class="p-5 p-l-15 p-r-15">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'cushion' }"
            @click="filtros[1].value === 'cushion' ? filtros[1].value = '*' : filtros[1].value = 'cushion'"
          >
            <img src="assets/img/corte/cushion.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Cushion</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'esmeralda' }"
            @click="filtros[1].value === 'esmeralda' ? filtros[1].value = '*' : filtros[1].value = 'esmeralda'"
          >
            <img src="assets/img/corte/esmeralda.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Esmeralda</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'marqueza' }"
            @click="filtros[1].value === 'marqueza' ? filtros[1].value = '*' : filtros[1].value = 'marqueza'"
          >
            <img src="assets/img/corte/marquesa.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Marquesa</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'ovalado' }"
            @click="filtros[1].value === 'ovalado' ? filtros[1].value = '*' : filtros[1].value = 'ovalado'"
          >
            <img src="assets/img/corte/ovalado.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Ovalado</span>
          </f7-col>
        </f7-row>
        <f7-row class="p-5 p-l-15 p-r-15">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'pera' }"
            @click="filtros[1].value === 'pera' ? filtros[1].value = '*' : filtros[1].value = 'pera'"
          >
            <img src="assets/img/corte/pera.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Pera</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'radiante' }"
            @click="filtros[1].value === 'radiante' ? filtros[1].value = '*' : filtros[1].value = 'radiante'"
          >
            <img src="assets/img/corte/radiant.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Radiant</span>
          </f7-col>
          <f7-col></f7-col>
          <f7-col></f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-290 sheet-border-radius-15" :opened="filtro === 'decorativa'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Decorativa</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="m-t-15 p-5 p-l-15 p-r-15">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[5].value === '3 piedras' }"
            @click="filtros[5].value === '3 piedras' ? filtros[5].value = '*' : filtros[5].value = '3 piedras'; filtros[2].value = filtros[6].value = filtros[7].value = '*'"
          >
            <img src="assets/img/decorativa/piedras_3.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">3 Piedras</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].value === 'chanel' }"
            @click="filtros[2].value === 'chanel' ? filtros[2].value = '*' : filtros[2].value = 'chanel'; filtros[5].value = filtros[6].value = filtros[7].value = '*'"
          >
            <img src="assets/img/decorativa/channel.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Channel</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[5].value === 'halo' }"
            @click="filtros[5].value === 'halo' ? filtros[5].value = '*' : filtros[5].value = 'halo'; filtros[2].value = filtros[6].value = filtros[7].value = '*'"
          >
            <img src="assets/img/decorativa/halo.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Halo</span>
          </f7-col>
        </f7-row>
        <f7-row class="p-5 p-l-15 p-r-15">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].value === 'pave' }"
            @click="filtros[2].value === 'pave' ? filtros[2].value = '*' : filtros[2].value = 'pave'; filtros[5].value = filtros[6].value = filtros[7].value = '*'"
          >
            <img src="assets/img/decorativa/pave.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Pave</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[6].value === 0 }"
            @click="filtros[6].value === 0 ? filtros[6].value = '*' : filtros[6].value = 0; filtros[2].value = filtros[5].value = filtros[7].value = '*'"
          >
            <img src="assets/img/decorativa/laterales.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Laterales</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[7].value === 0 }"
            @click="filtros[7].value === 0 ? filtros[7].value = '*' : filtros[7].value = 0; filtros[2].value = filtros[5].value = filtros[6].value = '*'"
          >
            <img src="assets/img/decorativa/solitario.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Solitario</span>
          </f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-210 sheet-border-radius-15" :opened="filtro === 'material'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Material</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="m-t-15 p-5 p-l-15 p-r-15">
          <f7-col
            class="p-7 text-center"
            :class="{ 'filter-selected': filtros[3].value === '10K' }"
            @click="filtros[3].value === '10K' ? filtros[3].value = '*' : filtros[3].value = '10K'"
          >
            <img src="assets/img/material/kilates_10.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">10 kilates</span>
          </f7-col>
          <f7-col
            class="p-7 text-center"
            :class="{ 'filter-selected': filtros[3].value === '14K' }"
            @click="filtros[3].value === '14K' ? filtros[3].value = '*' : filtros[3].value = '14K'"
          >
            <img src="assets/img/material/kilates_14.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">14 kilates</span>
          </f7-col>
          <!-- <f7-col
            class="p-7 text-center"
            :class="{ 'filter-selected': filtros[3].value === 'plata' }"
            @click="filtros[3].value === 'plata' ? filtros[3].value = '*' : filtros[3].value = 'plata'"
          >
            <img src="assets/img/material/platino.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Plata</span>
          </f7-col> -->
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-210 sheet-border-radius-15" :opened="filtro === 'color'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Color</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="m-t-15 p-5 p-l-15 p-r-15">
          <f7-col
            class="p-7 text-center"
            :class="{ 'filter-selected': filtros[4].value === 'amarillo' }"
            @click="filtros[4].value === 'amarillo' ? filtros[4].value = '*' : filtros[4].value = 'amarillo'"
          >
            <img src="assets/img/color/oro_amarillo.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Oro Amarillo</span>
          </f7-col>
          <f7-col
            class="p-7 text-center"
            :class="{ 'filter-selected': filtros[4].value === 'blanco' }"
            @click="filtros[4].value === 'blanco' ? filtros[4].value = '*' : filtros[4].value = 'blanco'"
          >
            <img src="assets/img/color/oro_blanco.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Oro Blanco</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[4].value === 'rosa' }"
            @click="filtros[4].value === 'rosa' ? filtros[4].value = '*' : filtros[4].value = 'rosa'"
          >
            <img src="assets/img/color/oro_rosa.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Oro Rosa</span>
          </f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-250 sheet-border-radius-15" :opened="filtro === 'precio'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Precio</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-list simple-list class="m-0 m-t-20 f7-list-item-no-border p-l-25 p-r-25">
          <f7-list-item>
            <f7-list-item-cell class="width-auto flex-shrink-0 m-0">
              <!-- <f7-icon ios="f7:money_dollar_round" md="material:attach_money"></f7-icon>-->
            </f7-list-item-cell>
            <f7-list-item-cell class="flex-shrink-3">
              <f7-range
                ref="precio"
                :min="priceMin"
                :max="priceMax"
                :step="1"
                :value="[filtros[0].minValue, filtros[0].maxValue]"
                :label="true"
                :dual="true"
                @range:change="onChange"
              ></f7-range>
            </f7-list-item-cell>
            <f7-list-item-cell class="width-auto flex-shrink-0">
              <!-- <f7-icon ios="f7:money_dollar_round_fill" md="material:monetization_on"></f7-icon>-->
            </f7-list-item-cell>
          </f7-list-item>
        </f7-list>
        <f7-row>
          <f7-col></f7-col>
          <f7-col>
            <f7-list no-hairlines-md class="m-t-5">
              <f7-list-input
                label="Mínimo"
                type="number"
                placeholder="Mínimo"
                :value="filtros[0].minValue"
                @input="filtros[0].minValue = Number($event.target.value)"
              ></f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list no-hairlines-md class="m-t-5">
              <f7-list-input
                label="Máximo"
                type="number"
                placeholder="Máximo"
                :value="filtros[0].maxValue"
                @input="filtros[0].maxValue = Number($event.target.value)"
              ></f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>
  </f7-page>
</template>

<script>
import busqueda from '@/components/busqueda'
import pasos from '@/components/pasos'
import listCompromiso from '@/components/list-compromiso.vue'

export default {
  components: {
    busqueda,
    pasos,
    listCompromiso
  },
  data () {
    return {
      diamante: {},
      cargando: true,
      activarBusqueda: false,
      catalogo: [],
      catalogoFiltrado: [],
      catalogoPaginador: [],
      filtros: [
        {
          prop: 'price',
          minValue: 0,
          maxValue: 0
        },
        {
          prop: 'c_cut',
          value: '*'
        },
        {
          prop: 'decorative1',
          value: '*'
        },
        {
          prop: 'specification',
          value: '*'
        },
        {
          prop: 'color',
          value: '*'
        },
        {
          prop: 'decorative2',
          value: '*'
        },
        {
          prop: 'laterales',
          value: '*'
        },
        {
          prop: 'solitario',
          value: '*'
        }
      ],
      filtro: '',
      priceMin: 0,
      priceMax: 0
    }
  },
  methods: {
    async init () {
      try {
        this.cargando = true
        this.$f7.dialog.preloader('Descargando catálogo...')
        this.catalogo = await this.$api.catalogo.compromiso()
        // TODO: limpiar DB y eliminar elementos con valor NULL
        this.catalogo = this.catalogo.filter(item => item.name !== null)
        // Buscar precios mínimos y máximos
        this.catalogo.forEach((item, idx) => {
          if (idx === 0) {
            this.priceMin = item.price
            this.priceMax = item.price
          }
          if (Math.floor(this.priceMin) !== 0) {
            this.priceMin = item.price < this.priceMin ? item.price : this.priceMin
          }
          this.priceMax = item.price > this.priceMax ? item.price : this.priceMax
        })
        // Asignar precios mínimos y máximos a filtros y range
        this.filtros[0].minValue = this.$refs.precio.f7Range.min = Math.floor(this.priceMin)
        this.filtros[0].maxValue = this.$refs.precio.f7Range.max = Math.ceil(this.priceMax)

        if (this.$f7.router.context && this.$f7.router.context.decorativa) {
          let decorativa = this.$f7.router.context.decorativa
          if (decorativa === '3 piedras') { this.filtros[5].value = decorativa }
          if (decorativa === 'chanel') { this.filtros[2].value = decorativa }
          if (decorativa === 'halo') { this.filtros[5].value = decorativa }
          if (decorativa === 'pave') { this.filtros[2].value = decorativa }
          if (decorativa === 'laterales') { this.filtros[6].value = 0 }
          if (decorativa === 'solitario') { this.filtros[7].value = 0 }
        }
        // Checar si se hay algun diamante seleccionado y reajustar filtros
        if (this.storage.diamante !== '') {
          this.diamante = await this.$api.catalogo.detallesDiamante(this.storage.diamante)

          this.catalogo = this.catalogo.filter(itm => {
            // Activar cuando se necesite filtrar por peso de diamante

            // if (itm.c_weight) {
            //   let carat = Number(this.diamante.Carat) || 0
            //   let piedraCentral = itm.c_weight.replace(/\s/g, '').replace(/QT/g, '').split('-')
            //   let min = 0
            //   let max = 0
            //   if (piedraCentral.length === 2) {
            //     min = Number(piedraCentral[0])
            //     if (piedraCentral[1] === 'X') {
            //       max = 6
            //     }
            //   }
            //   return (carat >= min && carat <= max) && (itm.c_cut.toLowerCase() === this.obtenerForma(this.diamante.Cut.toLowerCase()))
            // } else {
            //   return false
            // }
            return itm.c_cut.toLowerCase() === this.obtenerForma(this.diamante.Cut.toLowerCase())
          })
        }
        this.cargando = false
        this.$f7.dialog.close()
      } catch (err) {
        this.catalogo = []
        this.cargando = false
        this.$f7.dialog.close()
      }
    },
    limpiarFiltros () {
      this.filtros.forEach((itm, idx) => {
        if (this.diamante.Carat) {
          if (idx !== 1) {
            if (this.filtros[idx].value) { this.filtros[idx].value = '*' }
          }
        } else {
          if (this.filtros[idx].value) { this.filtros[idx].value = '*' }
        }
      })
      this.$refs.precio.setValue([this.priceMin, this.priceMax])
    },
    actualizarElemento (item) {
      this.$set(this.catalogo, this.catalogo.findIndex(itm => itm.cve === item.cve), item)
      this.$set(this.catalogoFiltrado, this.catalogoFiltrado.findIndex(itm => itm.cve === item.cve), item)
      this.$set(this.catalogoPaginador, this.catalogoPaginador.findIndex(itm => itm.cve === item.cve), item)
    },
    onChange (values) {
      clearTimeout(this.delayBusqueda)

      this.delayBusqueda = setTimeout(() => {
        this.$set(this.filtros, 0, { minValue: values[0], maxValue: values[1], prop: 'price' })
      }, 250)
    },
    onPageClose () {
      this.$evento.off('update-content')
    },
    obtenerEstiloCorregido (estilo) {
      if (estilo === 'PRINCESS') {
        return 'PRINCESA'
      } else if (estilo === 'CORAZON') {
        return 'CORAZÓN'
      } else if (estilo === 'MARQUEZA') {
        return 'MARQUESA'
      } else if (estilo === 'RADIANT') {
        return 'RADIANTE'
      } else {
        return estilo
      }
    },
    obtenerForma (forma) {
      if (forma.toUpperCase() === 'REDONDO') {
        return 'redondo'
      } else if (forma.toUpperCase() === 'RADIANTE') {
        return 'radiant'
      } else if (forma.toUpperCase() === 'PRINCESA') {
        return 'princess'
      } else if (forma.toUpperCase() === 'ASSCHER') {
        return 'asscher'
      } else if (forma.toUpperCase() === 'CUSHION') {
        return 'cushion'
      } else if (forma.toUpperCase() === 'MARQUESA') {
        return 'marqueza'
      } else if (forma.toUpperCase() === 'ESMERALDA') {
        return 'esmeralda'
      } else if (forma.toUpperCase() === 'CORAZÓN') {
        return 'corazon'
      } else if (forma.toUpperCase() === 'OVALADO') {
        return 'ovalado'
      } else if (forma.toUpperCase() === 'PERA') {
        return 'pera'
      } else if (forma.toUpperCase() === 'TRILLION') {
        return 'trillion'
      }
    }
  },
  created () {
    this.init()
    this.$evento.on('update-content', this.actualizarElemento)
  }
}
</script>

<style scoped>
.thumb {
  height: 150px;
}

.input-with-value {
  text-align: center !important;
}
</style>
